import React from 'react';
import { useTranslation } from 'react-i18next';
// MUI
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
// PROJECT
import ConfirmDialog from '../../../../commons/components/ConfirmDialog';

function Form(props) {
  const {
    formIsOpen,
    formControls,
    invalidFormControls,
    formControlsChanged,
    toggleForm,
    submitForm,
  } = props;

  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={formIsOpen}
      maxWidth="sm"
      title={t(formControls.id ? 'Edit equipment' : 'Create equipment')}
      cancel={toggleForm}
      accept={submitForm}>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextField
            value={formControls.name}
            onChange={formControlsChanged}
            fullWidth
            id="name"
            label={t('Name')}
            error={invalidFormControls.name}
            helperText={invalidFormControls.name && t('Name required')}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            value={formControls.code}
            onChange={formControlsChanged}
            fullWidth
            id="code"
            label={t('Code')}
            error={invalidFormControls.code}
            helperText={invalidFormControls.code && t('Code required')}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </Grid>
    </ConfirmDialog>
  );
}

export default Form;
